import { toPhoneNumber } from '@hourly/utilities';

export class Contact {
  public name: string;
  public email: string;
  public phoneNumber: string;

  constructor(name: string, email: string, phoneNumber: string) {
    this.name = name;
    this.email = email;
    this.phoneNumber = phoneNumber;
  }

  get phoneNumberFormatted(): string {
    return toPhoneNumber(this.phoneNumber);
  }
}
